var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        transition: "dialog-top-transition",
        "max-width": 600,
        "max-height": 900
      },
      model: {
        value: _vm.value,
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", {
            staticClass: "justify-center",
            domProps: {
              textContent: _vm._s(
                "Delete invitation for " + _vm.userInvite.email
              )
            }
          }),
          _vm._v(" "),
          _c("v-card-subtitle", {
            staticClass: "justify-center",
            domProps: {
              textContent: _vm._s(
                "Once deleted, the user will no longer be able to sign-up. This invite will be deleted from the database."
              )
            }
          }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-center" },
            [
              _vm.$auth.user.role === _vm.Role.Admin ||
              _vm.$auth.user.role === _vm.Role.TrialAdmin
                ? _c("AppButton", {
                    domProps: { textContent: _vm._s("Delete") },
                    on: {
                      click: function($event) {
                        return _vm.handleDeleteUserInvite()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("AppButton", {
                staticClass: "secondary",
                domProps: { textContent: _vm._s("Close") },
                on: {
                  click: function($event) {
                    return _vm.$emit("input", false)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }